import React, { useLayoutEffect } from 'react';
import { BrowserRouter, Navigate, Routes, Route, useLocation } from 'react-router-dom';

// Scroll to top on route change and initial load
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Force scroll to top synchronously before paint
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

import Layout from './components/Layout';

// Pages
import Home from './pages/Home';
import Research from './pages/Research';
import About from './pages/About';
import Products from './pages/Products';
import AIMemory from './pages/AIMemory';
import WhenAliveStopsBeingOperationalQuestion from './pages/WhenAliveStopsBeingOperationalQuestion';
import MiraMemoryInferenceRetrievalArchitecture from './pages/MiraMemoryInferenceRetrievalArchitecture';

// Legal Pages (keep existing)
import PrivacyPolicy from './components/PrivacyPolicy';
import AppPrivacyPolicy from './components/AppPrivacyPolicy';
import AppTermsOfService from './components/AppTermsOfService';
import DataUsageOverview from './components/DataUsageOverview';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="w-full min-h-screen bg-canvas selection:bg-text-primary selection:text-canvas overflow-x-clip">
        {/* Skip to main content link for keyboard navigation */}
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-white focus:text-black focus:rounded focus:outline-2 focus:outline-white focus:outline-offset-2 focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2"
          style={{ left: 0 }}
        >
          Skip to main content
        </a>
        <Routes>
          {/* Layout wrapper keeps Navbar mounted */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/research" element={<Research />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/research/ai-memory" element={<AIMemory />} />
            <Route path="/research/when-alive-stops-being-the-operational-question" element={<WhenAliveStopsBeingOperationalQuestion />} />
            <Route path="/research/introducing-mira" element={<MiraMemoryInferenceRetrievalArchitecture />} />
            <Route path="/research/mira-memory-inference-retrieval-architecture" element={<Navigate to="/research/introducing-mira" replace />} />
          </Route>
          {/* Legal pages without layout */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/app-privacy" element={<AppPrivacyPolicy />} />
          <Route path="/app-terms" element={<AppTermsOfService />} />
          <Route path="/app-data-usage" element={<DataUsageOverview />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;
